var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1971",
    d: "M11.5833 8.66667C11.5833 10.2775 10.2775 11.5833 8.66667 11.5833C7.05584 11.5833 5.75 10.2775 5.75 8.66667C5.75 7.05584 7.05584 5.75 8.66667 5.75C10.2775 5.75 11.5833 7.05584 11.5833 8.66667Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66699 1.16797C12.7258 1.16797 16.167 4.52878 16.167 8.60611C16.167 12.7484 12.6698 15.6552 9.43949 17.6319C9.20408 17.7648 8.93787 17.8346 8.66699 17.8346C8.39612 17.8346 8.1299 17.7648 7.89449 17.6319C4.67024 15.6359 1.16699 12.7627 1.16699 8.60611C1.16699 4.52878 4.60819 1.16797 8.66699 1.16797Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d0b6524e1a0e2a4da87988461dc0ead3.svg";
export { ForwardRef as ReactComponent };